// import CreditCard from './svg-icons/genericCreditCard.svg'
const CreditCard = require('./svg-icons/genericCreditCard.svg')
const Pinterest = require('./svg-icons/Pinterest.svg')
const BannerAd = require('./svg-icons/bannerAd301.svg')
const Brush = require('./svg-icons/Brush.svg')
const CardSmall = require('./svg-icons/Card-small.svg')
const CardTop = require('./svg-icons/Card-top.svg')
const Cart = require('./svg-icons/Cart.svg')
const CaretRight = require('./svg-icons/Caret-Right.svg')
const Checkmark = require('./svg-icons/Checkmark.svg')
const CheckCir = require('./svg-icons/Check_Cir.svg')
const Chevron = require('./svg-icons/chevron.svg')
const Clock = require('./svg-icons/Clock.svg')
const Close = require('./svg-icons/Close.svg')
const Collection = require('./svg-icons/Collection.svg')
const Computer = require('./svg-icons/Computer.svg')
const DottedLine = require('./svg-icons/Dotted-line.svg')
const Download = require('./svg-icons/Download.svg')
const Email = require('./svg-icons/Email_outline.svg')
const ETLogo = require('./svg-icons/et-logo.svg')
const Eye = require('./svg-icons/Eye.svg')
const Filter = require('./svg-icons/Filter.svg')
const Facebook = require('./svg-icons/Facebook.svg')
const FooterCircle = require('./svg-icons/Footer-Circle.svg')
const Fonts = require('./svg-icons/Fonts.svg')
const Grid = require('./svg-icons/Grid.svg')
const Grid2 = require('./svg-icons/Grid_2.svg')
const Illustrator = require('./svg-icons/Illustrator.svg')
const Lifetime = require('./svg-icons/Lifetime.svg')
const Modules = require('./svg-icons/Modules.svg')
const Instagram = require('./svg-icons/Instagram.svg')
const Tag = require('./svg-icons/Tag.svg')
const Templates = require('./svg-icons/Templates.svg')
const Textures = require('./svg-icons/Texture.svg')
const Twitter = require('./svg-icons/Twitter.svg')
const Typography = require('./svg-icons/Typography.svg')
const Youtube = require('./svg-icons/Youtube.svg')
const Hey = require('./svg-icons/Hey.svg')
const Quote = require('./svg-icons/Quote.svg')
const DiscoverWhite = require('./svg-icons/Discover_white.svg')
const DiscoverDark = require('./svg-icons/Discover_dark.svg')
const VisaWhite = require('./svg-icons/Visa_white.svg')
const VisaDark = require('./svg-icons/Visa_dark.svg')
const PaypalWhite = require('./svg-icons/Paypal_white.svg')
const PaypalDark = require('./svg-icons/Paypal_dark.svg')
const MCWhite = require('./svg-icons/MC_white.svg')
const MCDark = require('./svg-icons/MC_dark.svg')
const AmexWhite = require('./svg-icons/Amex_white.svg')
const AmexDark = require('./svg-icons/Amex_dark.svg')
const Shutterfly = require('./svg-icons/Shutterfly_logo.svg')
const Vistaprint = require('./svg-icons/Vistaprint_logo.svg')
const Uprinting = require('./svg-icons/Uprinting-logo-ai-01.svg')
const FinerWorksLogo = require('./svg-icons/FinerWorksLogo.svg')

export const svgs = {
  Brush,
  CardSmall,
  CardTop,
  CaretRight,
  Cart,
  Checkmark,
  CheckCir,
  Chevron,
  Clock,
  Close,
  Computer,
  CreditCard,
  DottedLine,
  Download,
  Email,
  ETLogo,
  Eye,
  Facebook,
  Filter,
  FooterCircle,
  Fonts,
  Grid,
  Grid2,
  Hey,
  Illustrator,
  Instagram,
  Lifetime,
  Modules,
  Collection,
  Pinterest,
  Tag,
  Templates,
  Textures,
  Twitter,
  Typography,
  Youtube,
  Quote,

  // logos
  DiscoverWhite,
  VisaWhite,
  PaypalWhite,
  MCWhite,
  AmexWhite,
  DiscoverDark,
  VisaDark,
  PaypalDark,
  MCDark,
  AmexDark,

  // Custom Pages
  BannerAd,
  Shutterfly,
  Vistaprint,
  Uprinting,
  FinerWorksLogo
}
